










	import { Ref, Prop, Vue, Component } from "vue-property-decorator";

	// Model Class
	import { UIModel } from "./../../UIModel";

	@Component({
		components: {},
	})
	export default class App extends Vue {
		// Props
		@Prop({ required: true }) public model!: UIModel;

		// Data
		public menu_items: any[] = [
			{
				label: "Issues",
				route: "/issues",
				icon: "exclamation",
				// disabled: this.model.selectedProject === null
				disabled: !this.model.hasEntitlement(String(process.env.VUE_APP_ISSUE_PRODUCT_CODE)),
				visible: this.model.hasEntitlement(String(process.env.VUE_APP_ISSUE_PRODUCT_CODE)),
			},
			// {
			//     "label": "Mail",
			//     "route": "/mail",
			// 	"icon": "envelope",
			// 	disabled: true,
			// },
			// {
			// 	label: "Documents",
			// 	route: "/documents",
			// 	icon: "file-alt",
			// 	disabled: true,
            // },
            {
			    "label": "Coordinate",
			    "route": "/coordinate",
				"icon": "dumpster-fire",
				// disabled: this.model.selectedProject === null
				disabled: !this.model.hasLicense(String(process.env.VUE_APP_COORDINATE_PRODUCT_CODE)),
				visible: this.model.hasLicense(String(process.env.VUE_APP_COORDINATE_PRODUCT_CODE)),
			},
			// {
			//     "label": "Transmittals",
			//     "route": "/transmittals",
			// 	"icon": "exchange-alt",
			// 	disabled: true,
			// },
			// {
			//     "label": "Packages",
			//     "route": "/packages",
			// 	"icon": "cubes",
			// 	disabled: true,
			// },
			// {
			//     "label": "Tasks",
			//     "route": "/tasks",
			// 	"icon": "clipboard-list",
			// 	disabled: true,
			// },
			// {
			//     "label": "Lots",
			//     "route": "/lots",
			// 	"icon": "th",
			// 	disabled: true,
			// },
			// {
			//     "label": "Forms",
			//     "route": "/forms",
			// 	"icon": "address-card",
			// 	disabled: true,
			// },
			// {
			//     "label": "Gallery",
			//     "route": "/gallery",
			// 	"icon": "images",
			// 	disabled: true,
			// },
			// {
			// 	label: "Checklists",
			// 	route: "/checklists",
			// 	icon: "tasks",
			// 	disabled: true,
            // },
			// {
			// 	label: "SP Doc Sync",
			// 	route: "/spdocsync",
			// 	icon: "arrows-alt-h",
			// 	disabled: !this.model.hasLicense(String(process.env.VUE_APP_SP_DOC_SYNC_PRODUCT_CODE)),
            // },
            // {
			//     label: "Account",
			//     route: "/account",
            //     icon: "user-lock",
            //     disabled: true,
			// },
			// {
			//     "label": "Vendor Data",
			//     "route": "/vendors",
			// 	"icon": "shopping-cart",
			// 	disabled: true,
			// },
			// {
			//     "label": "Manuals",
			//     "route": "/manuals",
			// 	"icon": "folder-open",
			// 	disabled: true,
			// },
			{
				label: "Project Access",
				route: "/projectlist",
				icon: "project-diagram",
				disabled: !this.model.hasLicense(String(process.env.VUE_APP_PROJECT_LIST_PRODUCT_CODE)),
				visible: true
			},
			{
				label: "Bluebeam Access",
				route: "/bluebeam-access",
				icon: "project-diagram",
				disabled: (!this.model.hasLicense(String(process.env.VUE_APP_BLUEBEAM_CONNECT_PRODUCT_CODE)) 
				&& !this.model.hasEntitlement(String(process.env.VUE_APP_BLUEBEAM_CONNECT_PRODUCT_CODE))),
				visible: true
			},
		];

		public goToPage(destination: string) {
			if (this.$route.path !== destination) {
				this.$router.push({
					path: destination,
					params: { model: this.model as any },
				});
			}
		}
	}
